import { render, staticRenderFns } from "./MediaSosial.vue?vue&type=template&id=ddddf704&scoped=true"
import script from "./MediaSosial.vue?vue&type=script&lang=js"
export * from "./MediaSosial.vue?vue&type=script&lang=js"
import style0 from "./MediaSosial.vue?vue&type=style&index=0&id=ddddf704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddddf704",
  null
  
)

export default component.exports